import {
  CREATE_TASK_SUCCESS,
  FETCH_TASK_SEARCH_SUCCESS,
  FETCH_TASK_SUCCESS,
  GET_TASK_SUCCESS,
  SAVE_TASK_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  search:[],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_TASK_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_TASK_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_TASK_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_TASK_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_TASK_SEARCH_SUCCESS: {
      return {
        ...state,
        search: action.data,
      }
    }


    default:
      return state;
  }
}
